



























import Vue from 'vue'
import imageFile from '@/assets/img/logos/logo-donedone.svg'

export default Vue.extend({
  name: 'Maintenance',

  metaInfo(): any {
    return {
      title: 'Site Maintenance',
    }
  },

  data() {
    return {
      logo: {
        src: imageFile,
        alt: 'Logo DoneDone',
      },
      marketingWebsiteUrl: 'https://www.donedone.com/',
    }
  },
})
